import { render, staticRenderFns } from "./NewsFeedEditor.vue?vue&type=template&id=0c504a13&scoped=true&"
import script from "./NewsFeedEditor.vue?vue&type=script&lang=js&"
export * from "./NewsFeedEditor.vue?vue&type=script&lang=js&"
import style0 from "./NewsFeedEditor.vue?vue&type=style&index=0&id=0c504a13&lang=scss&scoped=true&"
import style1 from "./NewsFeedEditor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c504a13",
  null
  
)

export default component.exports